import { ShapeTypeProps } from '.'

const Shape = ({ color, ...props }: ShapeTypeProps) => {
  return (
    <svg width="122" height="122" viewBox="0 0 122 122" fill="none" {...props}>
      <path
        d="M61 0H122V61C122 94.6513 94.7076 122 61 122C27.3487 122 0 94.7076 0 61C0.0562668 27.2924 27.3487 0 61 0Z"
        fill={color}
      />
    </svg>
  )
}
export { Shape }
